// // src/pages/auth/SignupStep2Otp.jsx
// import React, { useState } from "react";
// import { Box, Button, TextField, Typography } from "@mui/material";
// import { useNavigate } from "react-router-dom";
// import AuthLayout from "../../components/AuthLayout";

// export default function SignupStep2Otp() {
//   const [otp, setOtp] = useState("");
//   const navigate = useNavigate();

//   const handleVerify = (e) => {
//     e.preventDefault();
//     // TODO: verify OTP logic
//     navigate("/auth/signup/step-3");
//   };

//   return (
//     <AuthLayout>
//       <Box
//         component="form"
//         onSubmit={handleVerify}
//         sx={{ display: "flex", flexDirection: "column", gap: 2 }}
//       >
//         {/* <Typography variant="h5" textAlign="center" fontWeight={600}> */}
//         <Typography
//                   textAlign="center"
//                   fontWeight={600}
//                   color="white"
//                   sx={{
//                     fontSize: {
//                       xs: '1.12rem', // small screens (phones)
//                       sm: '1.5rem',  // tablets
//                       md: '1.75rem', // laptops
//                       lg: '2rem',    // desktops
//                     },
                    
//                   }}
//           >
//           Step 2
//         </Typography>
//         <Typography variant="body2" textAlign="center">
//           Enter the 6-digit code sent to your email.
//         </Typography>

//         <TextField
//           label="OTP Code"
//           value={otp}
//           onChange={(e) => setOtp(e.target.value)}
//           required
//           fullWidth
//         />

//         <Button variant="contained" type="submit" size="large">
//           Verify OTP
//         </Button>
//       </Box>
//     </AuthLayout>
//   );
// }

import React, { useState, useRef, useEffect } from "react";
import { Box, Button, TextField, Typography, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import AuthLayout from "../../components/AuthLayout";
import API_BASE_URL from "../../config/api";

export default function SignupStep2Otp() {
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [loading, setLoading] = useState(false);
  const inputRefs = useRef([]);
  const [timeLeft, setTimeLeft] = useState(10 * 60); // 10 mins
  const navigate = useNavigate();
  const email = sessionStorage.getItem("signupEmail");

  // Countdown timer
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timer = setInterval(() => setTimeLeft((prev) => prev - 1), 1000);
    return () => clearInterval(timer);
  }, [timeLeft]);

  const formatTime = (seconds) => {
    const m = String(Math.floor(seconds / 60)).padStart(2, "0");
    const s = String(seconds % 60).padStart(2, "0");
    return `${m}:${s}`;
  };

  const handleChange = (e, index) => {
    const value = e.target.value.replace(/\D/, ""); // Only digits
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // if (value && index < 5) inputRefs.current[index + 1].focus();
    if (value && index < 3) inputRefs.current[index + 1].focus();
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const handleVerify = async (e) => {
    e.preventDefault();
    const otpCode = otp.join("");
    if (otpCode.length !== 4) {
      toast.error("Please enter a 4-digit OTP code");
      return;
    }

    if (!email) {
      toast.error("Email not found. Please start from the beginning.");
      navigate("/signup");
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}/api/users/verify-signup-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, otp: otpCode }),
      });

      const data = await response.json();

      if (response.ok) {
        toast.success("OTP verified successfully!");
        navigate("/complete-signup");
      } else {
        toast.error(data.message || "Invalid OTP");
      }
    } catch (error) {
      console.error("Error verifying OTP:", error);
      toast.error("Failed to verify OTP. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout>
      <Box
        component="form"
        onSubmit={handleVerify}
        sx={{ display: "flex", flexDirection: "column", gap: 2 }}
      >
        <Typography
          textAlign="center"
          fontWeight={600}
          color="white"
          sx={{
            fontSize: {
              xs: "1.12rem",
              sm: "1.5rem",
              md: "1.75rem",
              lg: "2rem",
            },
          }}
        >
          Verify OTP
        </Typography>

        {/* <Typography variant="body2" textAlign="center">
          Enter the 6-digit code sent to your email.
        </Typography> */}

        {/* ✅ REPLACEMENT STARTS HERE (in place of your old TextField) */}
        <Stack
          direction="row"
          spacing={{ xs: 1, sm: 1.5 }}
          justifyContent="center"
          sx={{ mt: 1 }}
        >
          {otp.map((digit, index) => (
            <TextField
              key={index}
              inputRef={(el) => (inputRefs.current[index] = el)}
              value={digit}
              onChange={(e) => handleChange(e, index)}
              onKeyDown={(e) => handleKeyDown(e, index)}
              inputProps={{
                maxLength: 1,
                style: {
                  textAlign: "center",
                  fontSize: "1.2rem",
                  width: "2.3rem",
                  height: "2.6rem",
                },
              }}
              variant="outlined"
              sx={{
                "@media (max-width:600px)": {
                  "& input": { width: "2rem", height: "2.3rem", fontSize: "1rem" },
                },
                "@media (min-width:900px)": {
                  "& input": { width: "2.5rem", height: "2.8rem" },
                },
              }}
            />
          ))}
        </Stack>

        <Typography
          variant="body2"
          textAlign="center"
          sx={{ color: "gray", mt: 1 }}
        >
          Code will expire in {formatTime(timeLeft)}
        </Typography>
        {/* ✅ REPLACEMENT ENDS HERE */}

        <Button variant="contained" type="submit" size="large" disabled={loading}>
          {loading ? "Verifying..." : "Verify OTP"}
        </Button>
      </Box>
    </AuthLayout>
  );
}


